<script>
import GeneralForm from '@components/property-form-general'
import PreferencesForm from '@components/property-form-preferences'
import PolicyForm from '@components/property-form-policy'
import MemberForm from '@components/property-form-member'
import SocialMediaForm from '@components/property-form-socmed'

export default {
  metaInfo: {
    title: 'Property',
    meta: [{ name: 'description', content: 'Property' }],
  },

  components: {
    GeneralForm,
    PreferencesForm,
    PolicyForm,
    MemberForm,
    SocialMediaForm,
  },

  props: {
    property: {
      type: Object,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
    starRates: {
      type: Array,
      required: true,
    },
    timeZones: {
      type: Array,
      required: true,
    },
    currencies: {
      type: Array,
      required: true,
    },
    times: {
      type: Array,
      required: true,
    },
  },
}
</script>

<template>
  <BaseTabs title="Property" color="gold">
    <BaseTabsItem name="General">
      <GeneralForm />
    </BaseTabsItem>

    <BaseTabsItem name="Preferences">
      <PreferencesForm />
    </BaseTabsItem>

    <BaseTabsItem name="Policy">
      <PolicyForm />
    </BaseTabsItem>

    <BaseTabsItem name="Member">
      <MemberForm />
    </BaseTabsItem>

    <BaseTabsItem name="Social Media">
      <SocialMediaForm />
    </BaseTabsItem>
  </BaseTabs>
</template>
